export const routes = {
  admin: [
    {
      icon: 'mdi mdi-account-key-outline',
      label: 'Профиль',
      path: '/profile'
    },
    {
      icon: 'mdi mdi-briefcase-outline',
      label: 'Курсы',
      path: '/all-courses'
    },
    {
      icon: 'mdi mdi-file-upload-outline',
      label: 'База знаний',
      path: '/store'
    },
    {
      icon: 'mdi mdi-account-outline',
      label: 'Пользователи',
      path: '/all-users'
    },
    {
      icon: 'mdi mdi-account-group-outline',
      label: 'Группы',
      path: '/groups'
    },
    {
      icon: 'mdi mdi-home-city-outline',
      label: 'Филиалы',
      path: '/branches'
    },
    {
      icon: 'mdi mdi-bell-outline',
      label: 'Уведомления',
      path: '/my-notifications'
    },
    {
      icon: 'mdi mdi-file-document-box-multiple-outline',
      label: 'Заявки',
      path: '/my-requests'
    }
  ],
  user: [
    {
      icon: 'mdi mdi-account-key-outline',
      label: 'Профиль',
      path: '/profile'
    },
    {
      icon: 'mdi mdi-briefcase-outline',
      label: 'Мои курсы',
      path: '/my-courses'
    },
    {
      icon: 'mdi mdi-file-upload-outline',
      label: 'База знаний',
      path: '/store'
    },
    {
      icon: 'icon-pie-chart',
      label: 'Моя статистика',
      path: '/my-statistic'
    },
    {
      icon: 'mdi mdi-bell-outline',
      label: 'Уведомления',
      path: '/my-notifications'
    }
  ],
  leader: [
    {
      icon: 'mdi mdi-account-key-outline',
      label: 'Профиль',
      path: '/profile'
    },
    {
      icon: 'mdi mdi-account-outline',
      label: 'Пользователи',
      path: '/users'
    },
    {
      icon: 'mdi mdi-account-group-outline',
      label: 'Группы',
      path: '/groups'
    },
    {
      icon: 'mdi mdi-home-city-outline',
      label: 'Мой филиал',
      path: '/branches'
    },
    {
      icon: 'mdi mdi-bell-outline',
      label: 'Уведомления',
      path: '/my-notifications'
    }
  ],
  leader_admin: [
    {
      icon: 'mdi mdi-account-key-outline',
      label: 'Профиль',
      path: '/profile'
    },
    {
      icon: 'mdi mdi-account-outline',
      label: 'Пользователи',
      path: '/users'
    },
    {
      icon: 'mdi mdi-bell-outline',
      label: 'Уведомления',
      path: '/my-notifications'
    }
  ],
  methodist: [
    {
      icon: 'mdi mdi-account-key-outline',
      label: 'Профиль',
      path: '/profile'
    },
    {
      icon: 'mdi mdi-briefcase-outline',
      label: 'Курсы',
      path: '/all-courses'
    },
    {
      icon: 'mdi mdi-file-upload-outline',
      label: 'База знаний',
      path: '/store'
    }
  ]
}
